import React from 'react';
import { Box } from '@mui/material';
import { spacing } from 'common/theme';
import { HotYoterPurchasedBenefitCard } from '../../../../hot_yoter/components/HotYoterPurchasedBenefitCard';

const CardsList = ({ benefits, testID }) => (
    <Box
        testId={`${testID}-cards`}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: `${spacing.sm}px`,
            width: '100%',
        }}
    >
        {benefits.map((benefit, index) => (
            <HotYoterPurchasedBenefitCard
                key={benefit.id ?? `${benefit.name}-${index}`}
                benefit={benefit}
                inline
                showOrderDate
                testID={`${testID}-card-${index}`}
            />
        ))}
    </Box>
);

export const EligiblesPurchasedBenefits = ({
    purchasedBenefits = [],
    expanded = false,
    testID = 'hot-yoter-eligibles-popup-purchased',
}) => {
    if (!purchasedBenefits.length) {
        return null;
    }

    if (!expanded) {
        return null;
    }

    return (
        <Box
            testId={testID}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: `${spacing.sm}px`,
                width: '100%',
            }}
        >
            <CardsList benefits={purchasedBenefits} testID={testID} />
        </Box>
    );
};
